import { connect } from 'react-redux';

import Stepper from './stepper';

export default connect((state) => state)(Stepper);
